import { readUser, readUserId } from '@usehatchapp/javascript-sdk';
import { createImpersonationSession } from 'utils/impersonationSession';
import validateSchema from 'utils/validateSchema';

import { userConstants } from '../constants';
import { userSchema } from '../schema';

// read a currently logged in used session
// used to verify active user is still logged in
export const doReadUserSession =
  () =>
  async ({ dispatch, request, store, getState }) => {
    const {
      READ_USER_SESSION_FAILURE,
      READ_USER_SESSION_REQUEST,
      READ_USER_SESSION_SUCCESS,
    } = userConstants;

    try {
      const state = getState();
      const { apiKey: urlApiKey } = store.selectUrlParams(state);

      // tell state we're fetching user session
      dispatch({ type: READ_USER_SESSION_REQUEST });

      // Attempt to read session from url params
      if (urlApiKey) {
        createImpersonationSession({ apiKey: urlApiKey });
      }

      // get logged in user id
      const userId = await request(readUserId);

      // request user info
      const user = await request(readUser, { userId });

      // validate user data
      const validatedUser = validateSchema({
        payload: user,
        schema: userSchema,
      });

      // dispatch a success action with payload if we make it this far
      dispatch({ payload: validatedUser, type: READ_USER_SESSION_SUCCESS });
      // Trigger the fetch profile action creator to get the rest of the user object
      return dispatch({ actionCreator: 'doReadUserProfile' });
    } catch (error) {
      return dispatch({ error, type: READ_USER_SESSION_FAILURE });
    }
  };
